import { useStaticQuery, graphql } from "gatsby"
import { AffiliateFromStrapi, CampaignFromStrapi } from "../ts/interfaces"

let result: {
  affiliates: AffiliateFromStrapi[]
  campaigns: CampaignFromStrapi[]
}
export const useCampaignAndAffiliates = () => {
  if (result) {
    return result
  }
  const { allSensaiAffiliates, allSensaiCampaigns } = useStaticQuery(
    graphql`
      query {
        allSensaiAffiliates {
          nodes {
            id
            name
            code
            expiry
            duration
          }
        }
        allSensaiCampaigns {
          nodes {
            id
            name
            code
            source
            expiry
            duration
          }
        }
      }
    `
  )

  result = {
    affiliates: allSensaiAffiliates.nodes as AffiliateFromStrapi[],
    campaigns: allSensaiCampaigns.nodes as CampaignFromStrapi[],
  }
  return result
}
